// plugins/vue-apexcharts.js
import Vue from 'vue'
import VueApexCharts from 'vue-apexcharts'

Vue.component(`VueApexchart`, VueApexCharts)
